export default __webpack_public_path__ + "static/media/doctor5.cf59bb07.jpg";